import * as Yup from 'yup'

import { validationCode } from '../../utils/yup'

export const VALIDATE_CODE_SCHEMA = Yup.object().shape({
  validationCode
})
